<div class="notifications-viewer-container" #notificationcomponent>
  <!-- Header -->
  <div class="bfx-notifications-app-header">
    <span class="ds-cont-typography-productive-title-sm"
      >Notifications({{notifications.length}})</span
    >
    <bfx-icon-button
      size="sm"
      iconClass="icon_ion_settings_filled"
      (action)="showSettings()"
      title="Settings"
    ></bfx-icon-button>
  </div>

  <!-- Vertical list of notifications-->
  <div class="bfx-app-notification-list">
    <p-table
      #dl
      [first]="first"
      [value]="notifications"
      [rows]="pageSize"
      [paginator]="notifications.length>10"
      [style]="{'width' : '100%'}"
      [totalRecords]="notifications.length"
    >
      <ng-template pTemplate="body" let-note>
        <tr>
          <td>
            <div>
              <bfx-application-notification [data]="note"></bfx-application-notification>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <span class="bfx-empty-content">No Notifications</span>
      </ng-template>
    </p-table>
  </div>
  <!-- Footer -->
  <div class="bfx-notifications-app-footer">
    <!-- hidden div to ensure pagination is centred-->
    <div class="bfx-notification-button-spacer"></div>
    <div class="bfx-pagination-embedded" *ngIf="pageCount > 1">
      <button
        [disabled]="pageNo == 1"
        class="bfx-icon-button-sm bfx-icon-button-secondary-moderate-unsized"
        (click)="previousPage()"
      >
        <i class="icon-ion_chevron_left"></i>
      </button>
      {{pageNo}}/{{pageCount}}
      <button
        [disabled]="pageNo == pageCount"
        class="bfx-icon-button-sm bfx-icon-button-secondary-moderate-unsized"
        (click)="nextPage()"
      >
        <i class="icon-ion_chevron_right"></i>
      </button>
    </div>
    <button
      pButton
      type="button"
      [disabled]="notifications.length == 0"
      label="Clear All"
      class="bfx-button-secondary-bold bfx-button-sm"
      (click)="dismissAllNotifications()"
    ></button>
  </div>
</div>
